import React, { useEffect, useState, useRef, useMemo } from "react";
import { Modal } from "react-bootstrap";
import UseKeyPress from "components/helpers/UseKeyPress";
import useQueryQueue from "components/hooks/useQueryQueue";
import Button from "components/ui/Button/Button";
import Grid from "components/ui/Grid/Grid";
import InputMaterial from "components/ui/Input/InputMaterial";
import modalCss from "components/ui/Modal/Modal.module.css";
import useQueryState from "components/hooks/useQueryState";
import Formato from "components/helpers/Formato";
import SearchSelectMaterial, {
  mapOptions,
  includeSearch,
} from "components/ui/Select/SearchSelectMaterial";
import useAfiliacionesPorEmpresa from "./useAfiliacionesPorEmpresa";
import { useSelector } from "react-redux";
import useEmpresas, {
  onLoadSelectKeepOrFirst,
} from "components/pages/administracion/empresas/useEmpresas";
import AfiliacionesPorEmpresaDetalleTable from "./afiliacionesPorEmpresaDetalle/AfiliacionesPorEmpresaDetalleTable";
import useAmbitos from "components/hooks/useAmbitos";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import useDocumentaciones from "components/documentacion/useDocumentaciones";
import { generarPDFLibSolicitudAfiliacion } from "components/pages/afiliados/PDFLibSolicitudAfiliacion/generarPDFLibSolicitudAfiliacion";

const onChangeDef = (changes = {}) => {};
const onCloseDef = (confirm = false) => {};
const onValidateDef = (confirm = false) => {};

/**
 * Proceso a ejecutar posterior carga
 * @param {object} changes datos posterior carga
 * @param {array} changes.data datos obtenidos en la carga
 * @param {object} changes.error error durante la carga
 */

//#region seccionalSelect Options
const seccionalSelectOptions = ({ data = [], buscar = "", ...x }) =>
  mapOptions({
    data,
    map: (r) => ({ value: r.id, label: r.descripcion, record: r }),
    filter: (r) => includeSearch(r, buscar),
    ...x,
  });
//#endregion seccionalSelect Options

const AfiliacionesPorEmpresaForm = ({
  data = {},
  title = "",
  disabled = {},
  hide = {},
  errors = {},
  onChange = onChangeDef,
  onClose = onCloseDef,
  onValidate = onValidateDef,
  loading = {},
  estadosSolicitudes = [],
  request = "",
}) => {
  data ??= {};
  estadosSolicitudes ??= [];
  request ??= {};

  hide ??= {};
  errors ??= {};
  onChange ??= onChangeDef;
  onClose ??= onCloseDef;
  onValidate ??= onValidateDef;

  const [documentacionList, setDocumentacionList] = useState([]);
  const { request: solicitudAfiliacion } = useAfiliacionesPorEmpresa();
  const [empresa, setEmpresa] = useState({
    id: 0,
    cuit: null,
    razonsocial: "",
    domicilio: "",
    localidad: "",
    provincia: "",
    actividad:" "
  });
  
  //#region Alert
  const [dialog, setDialog] = useState({
    text: "",
    open: false,});
  const usuarioLogueado = useSelector((state) => state.usuarioLogueado);
  const ambito = useAmbitos().ambitoUser();
  const seccionalPredeterminadaSet = useRef(false);
  const [totalesTrabajadores, setTotalesTrabajadores] = useState({
    loading: false,
    totales: null,
    error: null,
  });
  const [generandoPDF, setGenerandoPDF] = React.useState(false);
  const [bloqueActual, setBloqueActual] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [pdfGenerado, setPdfGenerado] = useState(null);
  
  const [totalesUltimoPeriodoSinAfiliados, setTotalesUltimoPeriodoSinAfiliados] = useState(null)
  
  const [trabajadoresRuralesNoAfiliados, setTrabajadoresRuralesNoAfiliados] = useState({
    loading: false,
    data: [],
    error: null,
    });
  //#endregion

  const [documentacionTab, documentacionChanger, documentacionSelected] = useDocumentaciones();

   // Calcula la fecha de 3 meses atrás
  const getFechaTresMesesAtras = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 2);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }; 

  const [filtros, setFiltros] = useState({
    desde: getFechaTresMesesAtras(),
    hasta: new Date(),
    cuit: "",
    razonSocial: "",
    estado: 0,
  });

  const [paramsEdit, setParamsEdit] = useState({});
  const [paramsSend, setParamsSend] = useState({});

  //columnas para ocultar 
  const columnsDef = [
    {
      dataField: "cuit",
      text: "CUIT",
      sort: true,
      formatter: Formato.Cuit,
      headerStyle: (_colum, _colIndex) => ({ width: "150px" }),
    },
    {
      dataField: "razonSocial",
      text: "Razon Social",
      sort: true,
      style: { textAlign: "left" },
    },
{
      dataField: "provinciaDescripcion",
      text: "Provincia",
      sort: false,
      style: { textAlign: "left" },
    },
    {
      dataField: "localidadDescripcion",
      text: "Localidad",
      sort: false,
      style: { textAlign: "left" },
    },

    {
      dataField: "actividadPrincipalDescripcion",
      text: "Actividad Principal",
      hidden: true,
      style: { textAlign: "left" },
    },
    {
      dataField: "domicilioCalle",
      text: "Domicilio",
      hidden: true,
      style: { textAlign: "left" },
    },
    {
      dataField: "telefono",
      hidden: true,
      headerStyle: (_colum, _colIndex) => ({ width: "150px" }),
      text: "Teléfono",
      style: { textAlign: "left" },
    },
    {
      dataField: "deletedDate",
      text: "Fecha baja",
      hidden: true,
      formatter: Formato.Fecha,
      headerStyle: { width: "100px" },
      style: (v) => {
        const r = { textAlign: "center" };
        if (v) {
          r.background = "#ff6464cc";
          r.color = "#FFF";
        }
        return r;
      },
    },
  ];

  const {
    render: empresasRender,
    request: empresasRequest,
    selected: empresaSelected,
  } = useEmpresas({
    params: { orderBy: "razonSocial", soloActivos: true },
    onLoadSelect: onLoadSelectKeepOrFirst,
    columns: columnsDef,
  });

  const onGrabarSolicitudAfiliacion = (solicitud, trabajadoresAfipConsulta) => {

    pushQuery({
      action: "PostSolicitudAfiliacionEmpresas",
      config:{
        body: solicitud,
      },
      onOk: (data) => {
        onDownloadSolicitudAfiliacion(trabajadoresAfipConsulta, data);
          setTrabajadoresRuralesNoAfiliados({
            data: trabajadoresAfipConsulta,
            loading: false,
            error: null,
          });
      },
       onError: (error) => {
        setDialog({text: "No se pudo ingresar la Solicitud de Afiliación.", open: true});
        setTrabajadoresRuralesNoAfiliados({
          loading: false,
          data: null,
          error: error?.message || "Error al insertar Solicitud de Afiliación.",
        });
      },
    });
  };

  // CSS para las páginas
const style = document.createElement("style");
style.innerHTML = `
  .page {
    page-break-after: always;
    width: 210mm;   /* ancho A4 */
    min-height: 297mm; /* alto A4 */
    box-sizing: border-box;
  }
`;
document.head.appendChild(style);

const onDownloadSolicitudAfiliacion = async (trabajadoresNoAfiliados, afiliacionPorEmpresa) => {
  if (!trabajadoresNoAfiliados || trabajadoresNoAfiliados.length === 0) {
    setDialog({ text: "No hay trabajadores para generar el PDF.", open: true });
    return;
  }

  setGenerandoPDF(true);

  try {
    const chunkSize = 20;
    const totalChunks = Math.ceil(trabajadoresNoAfiliados.length / chunkSize);

    const datosCompletosPDF = [];

    for (let i = 0; i < totalChunks; i++) {
      setBloqueActual(i + 1);

      const chunk = trabajadoresNoAfiliados.slice(i * chunkSize, (i + 1) * chunkSize);

      const datosChunk = chunk.map((t) => ({
        afiliado_nro: t?.id,
        seccional_nro: seccionalSelect?.selectedRecord?.codigo,
        fecha: Formato.Fecha(new Date()),
        trabajador: {
          cuil: t?.cuil,
          tipo_doc: t?.tipoDocumento,
          nro_doc: t?.numeroDocumento,
          apellido: t?.afiliadoApellido,
          nombres: t?.afiliadoNombre,
          fecha_nacimiento: Formato.Fecha(t?.fechaNacimiento),
          domicilio_real: t?.domicilio,
          localidad: t?.localidad,
          provincia: t?.provincia,
          actividad: t?.actividadDescripcion.includes("inexistente") ? "-" : t?.actividadDescripcion,
        },
        empleador: {
          cuit: empresa?.cuit,
          nombre_o_razon_social: empresa?.razonsocial,
          domicilio: empresa?.domicilio,
          localidad: empresa?.localidad,
          provincia: empresa?.provincia,
          actividad: empresa?.actividad,
        },
      }));

      datosCompletosPDF.push(...datosChunk);
    }

    // Generamos un solo PDF con todos los trabajadores
    const base64PDF = await generarPDFLibSolicitudAfiliacion({
      datos: datosCompletosPDF,
      setBloqueActual,
      setTotalPaginas,
      descargar: false,
      nombreArchivo: "SolicitudesDeAfiliacion.pdf",
    });

    // Enviar a documentacionChanger
    documentacionChanger("Create", {
      params: {
        archivo: base64PDF.includes("base64,") ? base64PDF.split("base64,")[1] : base64PDF,
        entidadId: afiliacionPorEmpresa?.id,
        entidadTipo: "E",
        nombreArchivo: "SolicitudesDeAfiliacion.pdf",
        observaciones: "Solicitudes de Afiliación por Empresa",
        refTipoDocumentacionId: 6,
        soloactivos: true,
      },
    });

    onClose(true);
  } catch (error) {
    console.error("Error generando PDF:", error);
    setDialog({ text: "Error al generar el PDF.", open: true });
  } finally {
    setGenerandoPDF(false);
  }
};


  const { setState: setDocumentosQuery } = useQueryState(
    () => ({
      config: {
        baseURL: "Comunes",
        endpoint: `/DocumentacionEntidad/GetBySpec?EntidadId=${data.id}&EntidadTipo=O`,
        method: "GET",
      },
    }),
    { query: { config: { errorType: "response" } } }
  );


  //#region Carga inicial Documentacion
  useEffect(() => {
    setDocumentosQuery((o) => ({
      ...o,
      onLoad: ({ ok, error }) => {
        let data = [];
        if (Array.isArray(ok)) data = ok;
        setDocumentacionList(data ?? []);
      },
    }));
  }, [setDocumentosQuery]);
  //#endregion Carga inicial Documentacion

  const { setState: setSeccionalesQuery } = useQueryState(
    () => ({
      config: {
        baseURL: "Afiliaciones",
        endpoint: `/Seccional?SoloActivos=true&verSeccionalesLocalidades=false`,
        method: "GET",
      },
    }),
    { query: { config: { errorType: "response" } } }
  ); 

  //#region consultas API
  const pushQuery = useQueryQueue((action, params) => {
    switch (action) {
       case "ddjjTotalTrabajadores": {
        return {
          config: {
            baseURL: "DDJJ",
            endpoint: `/DDJJUatre/GetVAfiliacionesPorEmpresaCUITPeriodos`,
            method: "GET",
          },
        };
      }
      case "GetDDJJUatreTrabajadoresAFIPConsulta": {
        return {
          config: {
            baseURL: "DDJJ",
            endpoint: `/DDJJUatre/GetDDJJUatreTrabajadoresAFIPConsulta`,
            method: "GET",
          },
        };
      }
      case "PostSolicitudAfiliacionEmpresas": {
       return {
          config: {
            baseURL: "Afiliaciones",
            endpoint: "/SolicitudAfiliacionEmpresas",
            method: "POST" 
          },
        };
      }
      case "GetAfiliado": {
        const { CUIL } = params;
        return {
          config: {
            baseURL: "Afiliaciones",
            endpoint: `/Afiliado/GetAfiliadoByCUILValidado`,
            method: "GET",
          },
          params: { CUIL },
        };
      }
      case "ConsultaAFIP":{
	      return {
					config: {
						baseURL: "Comunes",
						endpoint: "/AFIPConsulta",
						method: "GET",
					},
				};
      }
      default:
        return null;
    }
  });
  //#endregion

  //#region select seccional
  const [seccionalSelect, setSeccionalSelect] = useState({
    loading: "Cargando...",
    buscar: "",
    data: [],
    error: null,
    options: [],
    selected: null,
    selectedRecord: null,
    origen: "",
  });
  // Filtrado de opciones por delegación
  useEffect(() => {
    if (seccionalSelect.data.length === 0) return;
    
    let dataFiltrada = seccionalSelect.data.filter((r) => r.id !== 99999);
    
    // Filtrar por delegación si corresponde
    if (ambito.tipo === 'Delegaciones') {
      const delegacionId = ambito.ids?.[0];
      if (delegacionId) {
        dataFiltrada = dataFiltrada.filter(s => s.refDelegacionId === delegacionId);
      }
    }
    
    const options = seccionalSelectOptions({ data: dataFiltrada, buscar: seccionalSelect.buscar });
    
    setSeccionalSelect((o) => ({ ...o, options }));
  }, [seccionalSelect.buscar, seccionalSelect.data, ambito.tipo, ambito.ids?.[0]]);
  //#endregion select seccionales

  // Actualizar selectedRecord cuando cambia selected
  useEffect(() => {
    const selectedValue = seccionalSelect.selected?.value;
    
    if (selectedValue) {
      const record = seccionalSelect.data.find((s) => s?.id === selectedValue);
      
      setSeccionalSelect((o) => {
        if (o.selectedRecord?.id !== record?.id) {
          return { ...o, selectedRecord: record };
        }
        return o;
      });
    } else {
      setSeccionalSelect((o) => {
        if (o.selectedRecord !== null) {
          return { ...o, selectedRecord: null };
        }
        return o;
      });
    }
  }, [seccionalSelect.selected?.value, seccionalSelect.data]);
  //#endregion select seccionales

  //#region Carga inicial select seccionales
  useEffect(() => {
    // Solo ejecutar cuando no se ha establecido una seccional predeterminada
    if (seccionalPredeterminadaSet.current) {
      return;
    }
    
    setSeccionalesQuery((o) => ({
      ...o,
      onLoad: ({ ok, error }) => {
        let allData = [];
        let seccionalesFiltered = [];
        let seccionalPredeterminada = null;

        if (Array.isArray(ok)) {
          allData = ok.filter((r) => r.id !== 99999);
          seccionalesFiltered = allData;

          // Si el ámbito es Delegaciones
          if (ambito.tipo === 'Delegaciones') {
                        const delegacionId = ambito.ids?.[0];
                        // Filtrar seccionales por la delegación actual (solo si hay delegación seleccionada)
                        if (delegacionId != null) {
                                       seccionalesFiltered = allData.filter((r) => r.refDelegacionId === delegacionId);
                        } 

            // Intentar obtener la seccional del usuario mediante Afiliado (por CUIL/CUIT)
            // Si no se encuentra o no pertenece a la delegación, se usará la primera seccional
            if (usuarioLogueado?.cuit && !seccionalPredeterminadaSet.current) {
              // Verificar si el usuario tiene una seccionalId directamente
              if (usuarioLogueado.seccionalId) {
                const seccionalUsuario = seccionalesFiltered.find(s => s.id === usuarioLogueado.seccionalId);
                if (seccionalUsuario) {
                  seccionalPredeterminada = seccionalUsuario;
                  seccionalPredeterminadaSet.current = true;
                  
                  setSeccionalSelect((o) => ({
                    ...o,
                    loading: null,
                    data: seccionalesFiltered,
                    error: error?.toString(),
                    selected: { value: seccionalPredeterminada.id, label: seccionalPredeterminada.descripcion }
                  }));
                  return;
                }
              }
              
              pushQuery({
                action: "GetAfiliado",
                params: { CUIL: usuarioLogueado.cuit },
                onOk: async (afiliado) => {
                  try {
                    const seccionalIdUsuario = afiliado?.seccionalId;
                    const seccionalUsuario = seccionalesFiltered.find(s => s.id === seccionalIdUsuario);
                    
                    if (seccionalUsuario && !seccionalPredeterminadaSet.current) {
                      seccionalPredeterminada = seccionalUsuario;
                      seccionalPredeterminadaSet.current = true;
                    } else if (seccionalesFiltered.length > 0 && !seccionalPredeterminadaSet.current) {
                      seccionalPredeterminada = seccionalesFiltered[0];
                      seccionalPredeterminadaSet.current = true;
                    }

                    setSeccionalSelect((o) => ({
                      ...o,
                      loading: null,
                      data: seccionalesFiltered,
                      error: error?.toString(),
                      ...(seccionalPredeterminada
                        ? { selected: { value: seccionalPredeterminada.id, label: seccionalPredeterminada.descripcion } }
                        : {}),
                    }));
                  } catch (e) {
                    // En caso de error, fallback a primera seccional disponible
                    if (seccionalesFiltered.length > 0 && !seccionalPredeterminadaSet.current) {
                      seccionalPredeterminada = seccionalesFiltered[0];
                      seccionalPredeterminadaSet.current = true;
                      setSeccionalSelect((o) => ({
                        ...o,
                        loading: null,
                        data: seccionalesFiltered,
                        error: error?.toString(),
                        selected: { value: seccionalPredeterminada.id, label: seccionalPredeterminada.descripcion },
                      }));
                    } else {
                      setSeccionalSelect((o) => ({ ...o, loading: null, data: seccionalesFiltered, error: error?.toString() }));
                    }
                  }
                },
                onError: async (err) => {
                  // No se encontró afiliado: fallback a primera seccional
                  if (seccionalesFiltered.length > 0 && !seccionalPredeterminadaSet.current) {
                    seccionalPredeterminada = seccionalesFiltered[0];
                    seccionalPredeterminadaSet.current = true;
                    setSeccionalSelect((o) => ({
                      ...o,
                      loading: null,
                      data: seccionalesFiltered,
                      error: error?.toString(),
                      selected: { value: seccionalPredeterminada.id, label: seccionalPredeterminada.descripcion },
                    }));
                  } else {
                    setSeccionalSelect((o) => ({ ...o, loading: null, data: seccionalesFiltered, error: error?.toString() }));
                  }
                },
              });
              // Salimos porque la actualización del estado se hará en los callbacks
              return;
            } else {
              // No hay CUIT del usuario: usar la primera seccional si aplica
              if (seccionalesFiltered.length > 0 && !seccionalPredeterminadaSet.current) {
                seccionalPredeterminada = seccionalesFiltered[0];
                seccionalPredeterminadaSet.current = true;
              }
            }
          } else if (ambito.tipo === 'Seccionales') {
            // Si es Seccionales, usar directamente la seccional del usuario
            const seccionalId = ambito.ids?.[0];
            
            if (seccionalId) {
              const seccionalUsuario = allData.find(s => s.id === seccionalId);
              if (seccionalUsuario && !seccionalPredeterminadaSet.current) {
                seccionalPredeterminada = seccionalUsuario;
                seccionalPredeterminadaSet.current = true;
              }
            }
          }
        }

        // Si no se necesitó consultar afiliado o ya no quedó mejor opción, actualizar estado normalmente
        setSeccionalSelect((o) => ({
          ...o,
          loading: null,
          data: seccionalesFiltered,
          error: error?.toString(),
          ...(seccionalPredeterminada
            ? { selected: { value: seccionalPredeterminada.id, label: seccionalPredeterminada.descripcion } }
            : {}),
        }));
      },
    }));
  }, [setSeccionalesQuery, ambito.tipo, ambito.ids, usuarioLogueado?.cuit]);
  //#endregion Carga inicial select seccionales
  
  //#region Resetear referencia al desmontar
  useEffect(() => {
    return () => {
      seccionalPredeterminadaSet.current = false;
    };
  }, []);
  //#endregion


   //Carga de lista según parametros
    useEffect(() => {
      empresasRequest("list", {
        params: paramsSend,
        pagination: { index: 1, size: 5 },
        onLoadSelect: onLoadSelectKeepOrFirst,
      });
    }, [empresasRequest, paramsSend]);
    //#endregion


  const handleConfirma = async () => {
  setGenerandoPDF(true);
  try {
    if (!totalesUltimoPeriodoSinAfiliados) {
      setDialog({ text: "No hay trabajadores para generar la Solicitud de Afiliación.", open: true });
      setGenerandoPDF(false);
      return;
    }

    setTrabajadoresRuralesNoAfiliados({ loading: true, data: [], error: null });

    const solicitud = {
      fecha: new Date().toISOString(),
      seccionalId: seccionalSelect.selected.value,
      empresaId: empresa?.id ?? 0,
      estadoSolicitudId: estadosSolicitudes?.find((o) => o?.descripcion === "Pendiente")?.id,
      estadoFecha: new Date().toISOString(),
      estadoSolicitudObservaciones: "Sin observaciones",
      estadoSolicitudUsuario: usuarioLogueado?.id || "desconocido",
      periodo: totalesUltimoPeriodoSinAfiliados?.periodo,
      total_Trabajadores: totalesUltimoPeriodoSinAfiliados?.total_Trabajadores,
      total_Trab_Rurales: totalesUltimoPeriodoSinAfiliados?.total_Trab_Rurales,
      total_Trab_NoRurales: totalesUltimoPeriodoSinAfiliados?.total_Trab_NoRurales,
      total_Trab_Rurales_Afiliados: totalesUltimoPeriodoSinAfiliados?.total_Trab_Rurales_Afiliados,
      total_Trab_Rurales_NoAfiliados: totalesUltimoPeriodoSinAfiliados?.total_Trab_Rurales_NoAfiliados,
      total_Trab_NoRurales_Afiliados: totalesUltimoPeriodoSinAfiliados?.total_Trab_NoRurales_Afiliados,
      total_Trab_NoRurales_NoAfiliados: totalesUltimoPeriodoSinAfiliados?.total_Trab_NoRurales_NoAfiliados,
      solicitudAfiliacionEmpresasDetalle: Array.isArray(totalesTrabajadores.totales)
        ? totalesTrabajadores.totales.map((item) => ({
            periodo: item.periodo,
            total_Trabajadores: item.total_Trabajadores,
            total_Trab_Rurales: item.total_Trab_Rurales,
            total_Trab_NoRurales: item.total_Trab_NoRurales,
            total_Trab_Rurales_Afiliados: item.total_Trab_Rurales_Afiliados,
            total_Trab_Rurales_NoAfiliados: item.total_Trab_Rurales_NoAfiliados,
            total_Trab_NoRurales_Afiliados: item.total_Trab_NoRurales_Afiliados,
            total_Trab_NoRurales_NoAfiliados: item.total_Trab_NoRurales_NoAfiliados,
          }))
        : [],
    };

    // Consultamos trabajadores rurales no afiliados
    pushQuery({
      action: "GetDDJJUatreTrabajadoresAFIPConsulta",
      params: {
        CUIT: totalesUltimoPeriodoSinAfiliados?.cuit,
        Periodo: totalesUltimoPeriodoSinAfiliados?.periodo,
        EsRural: "S",
        //SoloActivos: 1,  esta propiedad deberia reemplazar al afiliadoId en caso de que se quiera filtrar por trabajadores activos
        AfiliadoId: 0,
      },
      onOk: (data) => {
        if (!data || (Array.isArray(data) && data.length === 0)) {
          setDialog({text: "No se encontraron Trabajadores Rurales No Afiliados para generar la Solicitud de Afiliación.", open: true});
          setTrabajadoresRuralesNoAfiliados({
            loading: false,
            data: [],
            error: "No existen datos para el CUIT y período seleccionados.",
          });
        } else {
          onGrabarSolicitudAfiliacion(solicitud, data);
        }
      },
       onError: (error) => {
        setGenerandoPDF(false);
        setDialog({text: "Error consultando trabajadores", open: true});
        setTrabajadoresRuralesNoAfiliados({
          loading: false,
          data: null,
          error: error?.message || "Error al obtener los totales de trabajadores.",
        });
      },
    });
  } catch (error) {
    console.error(error);
    setDialog({ text: "Error al procesar la solicitud.", open: true });
    setGenerandoPDF(false);
    setTrabajadoresRuralesNoAfiliados({ loading: false, data: null, error: error.message });
  }
};

  UseKeyPress(["Escape"], () => onClose());
  UseKeyPress(["Enter"], () => handleConfirma(), "AltKey");


  const fechaToPeriodo = (fecha) => {
    if (!fecha) return "";
    if (fecha instanceof Date) {
      const y = fecha.getFullYear();
      const m = String(fecha.getMonth() + 1).padStart(2, "0");
      return `${y}${m}`;
    }
    if (typeof fecha === "string" && /^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
      const [y, m] = fecha.split("-");
      return `${y}${m}`;
    }
    if (typeof fecha === "string" && /^\d{6}$/.test(fecha)) {
      return fecha;
    }
    try {
      const d = new Date(fecha);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      return `${y}${m}`;
    } catch {
      return "";
    }
  };

const handlerBuscarTotales = () => {
    const cuit = String(empresaSelected.cuit).replace(/\D/g, "");
    const PeriodoDesde = fechaToPeriodo(filtros.desde);
    const PeriodoHasta = fechaToPeriodo(filtros.hasta);
    
    if (!cuit || !PeriodoDesde || !PeriodoHasta) return;

     pushQuery({
      action: "ConsultaAFIP",
      params: { cuit: empresaSelected?.cuit, VerificarHistorico: true },
      onOk: (data) => {
        setEmpresa({
            id: empresaSelected?.id,
            cuit: data?.cuit,
            razonsocial: data?.razonSocial,
            domicilio: data?.domicilios[0]?.direccion,
            localidad: data?.domicilios[0]?.localidad,
            provincia: data?.domicilios[0]?.descripcionProvincia,
            actividad: data?.descripcionActividadPrincipal
          });
      },
       onError: (error) => {
         setEmpresa({
            id: empresaSelected?.id,
            cuit: empresaSelected?.cuit,
            razonsocial: empresaSelected?.razonSocial,
            domicilio: `${empresaSelected?.domicilioCalle} ${empresaSelected?.domicilioNumero}`,
            localidad: "",
            provincia: "",
            actividad: empresaSelected?.actividadPrincipalDescripcion
          });
      },
    });

    setTotalesTrabajadores({ loading: true, totales: null, error: null});

    setTotalesUltimoPeriodoSinAfiliados(null);
    pushQuery({
      action: "ddjjTotalTrabajadores",
      params: {
        CUIT: cuit,
        PeriodoDesde,
        PeriodoHasta,
        Sort:"-Periodo",
        PageIndex: 1,
        PageSize: 6, // Ajusta el tamaño según sea necesario      
      },
      onOk: (data) => {
        
        if (!data.data || (Array.isArray(data.data) && data.data.length === 0)) {
          setTotalesTrabajadores({
            loading: false,
            totales: [],
            error: "No existen datos para el CUIT y período seleccionados.",
          });
        } else {
          
          //setTotalPaginas(Math.ceil(data?.total_Trab_Rurales_NoAfiliados / 20));
          setTotalesTrabajadores({ loading: false, totales: data?.data, error: null });
          setTotalesUltimoPeriodoSinAfiliados(data.data.find((item) => item.total_Trab_Rurales_NoAfiliados > 0) || null);
        }
      },
      onError: (error) => {
        setTotalesTrabajadores({
          loading: false,
          totales: null,
          error: error?.message || "Error al obtener los totales de trabajadores.",
        });
      },
    });
  };


  return (
    <>
      <Modal show size="xl" centered>
        <Modal.Header className={modalCss.modalCabecera} closeButton>
          <h3>{title}</h3>
          <Grid
            width="40%"
            float="right"
            style={{
              display: "flex",
              alignItems: "center",
              paddingleft: "65%",
              marginLeft: "25%",
            }}
          >
            <div>Seccional:</div>
            <SearchSelectMaterial
              id="seccionalId"
              label=""
              error={!!(seccionalSelect.error || errors.seccionalId)}
              helperText={
                seccionalSelect.loading ??
                seccionalSelect.error ??
                errors.seccionalId
              }
              value={seccionalSelect.selected}
              disabled={disabled.seccionalId || ambito.tipo === "Seccionales"}
              onChange={(selected) => {
                setSeccionalSelect((o) => ({
                  ...o,
                  selected: selected || null,
                  origen: "option",
                }));
                onChange({ seccionalId: selected?.value });
              }}
              options={seccionalSelect.options}
              onTextChange={(buscar) => {
                setSeccionalSelect((o) => ({ ...o, buscar, origen: "text" }));
              }}
            />
          </Grid>
        </Modal.Header>
        <Modal.Body>
            <Grid width col gap="10px">
              <Grid gap="inherit">
                <Grid width="700px" grow>
                  <InputMaterial
                    label="Filtro por CUIT / Razón social"
                    value={paramsEdit.filtro}
                    placeholder="Todas"
                    onChange={(filtro) =>
                      setParamsEdit((o) => {
                        const paramsEdit = { ...o, filtro };
                        if (!filtro) delete paramsEdit.filtro;
                        return paramsEdit;
                      })
                    }
                  />
                </Grid>
                <Grid width="200px">
                  <Button
                    className="botonAzul"
                    disabled={
                      JSON.stringify(paramsEdit) === JSON.stringify(paramsSend)
                    }
                    onClick={() => {
                      setParamsSend(paramsEdit);
                    }}
                  >
                    Aplica filtro
                  </Button>
                </Grid>
                <Grid width="200px">
                  <Button
                    className="botonAzul"
                    disabled={Object.entries(paramsEdit).length === 0}
                    onClick={() => {
                      const paramsEdit = {};
                      setParamsEdit(paramsEdit);
                      if (
                        JSON.stringify(paramsEdit) ===
                        JSON.stringify(paramsSend)
                      )
                        return;
                      setParamsSend({ ...paramsEdit });
                    }}
                  >
                    Limpia filtro
                  </Button>
                </Grid>
              </Grid>
              <div
                style={{
                  minHeight: 150,
                  maxHeight: 550,
                  overflowY: "auto",
                }}
              >
                {empresasRender()}
              </div>
            </Grid>
            <Grid width gap="inherit">
              {/* Reemplazo el filtro de estado por los de fecha */}
              <Grid width="auto">
                <InputMaterial
                  label="Desde"
                  disabled={true}
                  type="date"
                  value={filtros.desde || ""}
                  onChange={(e) => {
                    let value = e?.target?.value || e;
                    setFiltros((o) => ({ ...o, desde: value }));
                    setTotalesTrabajadores({
                      loading: false,
                      totales: null,
                      error: null,
                    });
                  }}
                />
              </Grid>
              <Grid width="auto">
                <InputMaterial
                  label="Hasta"
                  disabled={true}
                  type="date"
                  value={filtros.hasta || ""}
                  onChange={(e) => {
                    let value = e?.target?.value || e;
                    setFiltros((o) => ({ ...o, hasta: value }));
                    setTotalesTrabajadores({
                      loading: false,
                      totales: null,
                      error: null,
                    });
                  }}
                />
              </Grid>

              <Grid width="auto">
                <Button
                  className="botonAmarillo"
                  disabled={
                    !(empresaSelected && filtros.desde && filtros.hasta)
                  }
                  onClick={() => {
                    handlerBuscarTotales();
                  }}
                >
                  
                  {`ANALIZAR ${empresaSelected?.razonSocial.slice(0, 20)}...`}
                </Button>
              </Grid>
            </Grid>
            <Grid width="auto"  style={{ marginTop: "10px" }}>
              <AfiliacionesPorEmpresaDetalleTable
                mostrarBuscar={false}
                remote
                keyField="empresaCUIT"
                data={
                  Array.isArray(totalesTrabajadores?.totales) &&
                  totalesTrabajadores?.totales?.length > 0
                    ? totalesTrabajadores?.totales
                    : []
                }
                noDataIndication={
                  totalesTrabajadores?.loading
                    ? "Cargando..."
                    : totalesTrabajadores?.error
                    ? totalesTrabajadores?.error
                    : "No existen datos para el CUIT y período seleccionados."
                }
                onTableChange={(type, { sortOrder, sortField }) => {
                  switch (type) {
                    case "sort": {
                      sortField =
                        {
                          empresaCUIT: "cuit",
                          empresaRazonSocial: "razonsocial",
                        }[sortField] ?? sortField;
                      const sortBy = `${
                        sortOrder === "desc" ? "-" : "+"
                      }${sortField}`;
                      return;
                    }
                    default:
                      return;
                  }
                }}
               
              />
            </Grid>
        </Modal.Body>
        <Modal.Footer>
         <Button
            className="botonAzul"
            loading={loading}
            width={25}
            disabled={
              (totalesUltimoPeriodoSinAfiliados == null ||
                totalesUltimoPeriodoSinAfiliados?.total_Trab_Rurales_NoAfiliados === 0 ||
                trabajadoresRuralesNoAfiliados.loading ||
                generandoPDF) ?? false
            }
            onClick={() => handleConfirma()}
          >
            {generandoPDF && bloqueActual < totalPaginas
              ? `Generando PDF - Paso ${bloqueActual} de ${totalPaginas}...`
              : trabajadoresRuralesNoAfiliados.loading
              ? "Generando archivo PDF - Preparando datos"
              : "CONFIRMA"}
          </Button>

          <Button
            className="botonAmarillo"
            width={25}
            onClick={() => onClose()}
             disabled={
              (generandoPDF) ?? false
            }
          >
            CIERRA
          </Button>
        </Modal.Footer>
        <div>
            <Dialog
              onClose={() => (
                setDialog({text: "", open:false})
              )}
              open={dialog.open}
            >
              <DialogContent dividers>
                <Typography gutterBottom style={{ whiteSpace: "pre-line" }}>
                  {dialog.text}
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  className="botonAmarillo"
                  onClick={() => (
                     setDialog({text: "", open:false})
                  )}
                >
                  Cierra
                </Button>
              </DialogActions>
            </Dialog>
          </div>
      </Modal>
    </>
  );
};

export default AfiliacionesPorEmpresaForm;